// Square's own categories are unreliable (98 items sit under "Neuromodulator /
// Botox" incl. laser + add-ons), so the menu is classified from the name.
export const MENU_ORDER = [
  "Consultations",
  "Botox & Neuromodulators",
  "Fillers, Skin Boosters & Regenerative",
  "Facials, Hydrafacial & Peels",
  "Microneedling & RF",
  "Icon IPL (Tanya · Ottawa)",
  "Laser Genesis & IPL",
  "Laser Hair Removal",
  "Skin Tightening, Lesions & Light Therapy",
  "Brows & Lashes",
  "Add-Ons",
  "Other Treatments",
];

const RULES = [
  ["Consultations", /consult|follow[\s-]*up/i],
  ["Add-Ons", /add[\s-]*on/i],
  ["Icon IPL (Tanya · Ottawa)", /\bicon\b.*\b(ipl|maxg)\b/i],
  ["Botox & Neuromodulators", /^(?!.*filler)(?=.*(lip flip|microtox|micro tox))/i],
  ["Laser Genesis & IPL", /laser genesis|\bipl\b|photo\s*facial|photorejuv/i],
  ["Microneedling & RF", /micro\s*ne+d+l|rf needl|morpheus|potenza|\brf\b/i],
  ["Facials, Hydrafacial & Peels", /hydrafacial|facial|[ée]minence|peel|dermaplan|dermabrasion|lymphatic|power combo|glow package|\bmask\b|extraction|exfoliat/i],
  ["Laser Hair Removal", /laser hair|^\s*laser\s*[—–-]\s*|brazilian|bikini|underarm|\blegs?\b|\barms?\b|\bchest\b|areola|sideburn|linea|upper lip|\blaser\b|men's refresh/i],
  ["Fillers, Skin Boosters & Regenerative", /filler|\brha\b|juv[eé]derm|restylane|radiesse|redensity|booster|sculptra|exosome|\bprp\b|plasma|biostim|profhilo|baby glow|regenerie|renergie|lip enhance|\blips?\b|cheek|tear trough|jawline filler/i],
  ["Botox & Neuromodulators", /botox|neuromodulator|dysport|xeomin|nuceiva|\b11'?s\b|forehead|crow'?s|frown|brow lift|smile lift|nefertiti|masseter|mentalis|gummy|bunny|hyperhidrosis|platysm|neck band|jelly roll|trap[ae]z|d[eé]collat?e lines|migraine|bruxism|\btox\b|glow choice/i],
  ["Skin Tightening, Lesions & Light Therapy", /lesion|skin tag|\bmole\b|\bvein\b|tighten|rejuven|red light|\bled\b|co₂|co2/i],
  ["Brows & Lashes", /\bbrow\b|\blash\b/i],
];

export const menuCategory = (s) => {
  const name = s?.name || "";
  for (const [cat, re] of RULES) if (re.test(name)) return cat;
  return "Other Treatments";
};

export const isPromoService = (s) =>
  cleanName(s?.name) &&
  /\bpromo\b|makeover|maker over|door\s*crasher|\bspecial\b|\bbundle\b|flash|\bdeal\b|\boffer\b|glow choice|regenerie|renergie|non.?surgical facelift|^nefertiti lift|^baby glow —|laser genesis add-on|ultimate full face|mothers day|valentines|members only|glow reset|^\s*-?\$\d/i.test(cleanName(s?.name)) &&
  !/consult/i.test(s?.name || "");

export const makeoverNum = (s) => {
  const n = s?.name || "";
  if (/360\s*makeover/i.test(n)) return 50;
  const m = /mak(?:e|er\s*)over\s*(\d+)/i.exec(n) || /^\s*-?\s*(\d+)\s*\.?\s+.*mak(?:e|er\s*)over/i.exec(n);
  return m ? parseInt(m[1], 10) : 999;
};

// Strip Square sort prefixes only ("9. ", "- ", "1  Makeover") — keep "2D", "1/2", "8 Full Syringes"
export const cleanName = (n) => (n || "").replace(/^\s*#\s*[AL]?\d{1,3}\s*[·\-–—:.]\s*/i, "").replace(/^(\s*[-–—]+\s*|\s*\d+\.\s*|\s*\d+\s+(?=makeover))+/i, "").trim();

const PRICE_RE = /\s*[-—(]*\s*\$\s?[\d,]+(\s*\+\s*(tx|tax))?\s*(plus tax)?\)?[\s\-—:,]*/i;
// "Makeover 1 $299 number 11s…" → {title:"Makeover 1", detail:"number 11s…"}; otherwise title = name minus price
export const splitName = (raw) => {
  const n = cleanName(raw);
  const num = makeoverNum({ name: raw });
  const mk = /^(mak(?:e|er\s*)over\s*\d*)/i.exec(n);
  if (mk && num < 50) return { title: `Makeover ${num}`, detail: n.slice(mk[0].length).replace(PRICE_RE, " ").replace(/[()]/g, "").replace(/\s*[-—:,.]+\s*/g, " · ").replace(/^[\s·.]+|[\s·.]+$/g, "").trim() };
  const m = PRICE_RE.exec(n);
  if (!m) return { title: n, detail: "" };
  const before = n.slice(0, m.index).trim(); const after = n.slice(m.index + m[0].length).trim();
  if (before.length > 3) return { title: before, detail: after };
  return { title: after || n, detail: "" };
};

export const azCompare = (a, b) =>
  splitName(a.name).title.localeCompare(splitName(b.name).title, undefined, { sensitivity: "base", numeric: true });

// Winter Beauty Packages flyer order (Oct 2026) — pinned first, in this order
export const FLYER_PROMOS = [
  /non.?surgical facelift/i, /^nefertiti lift/i, /makeover\s*1\b/i, /makeover\s*2\b/i, /makeover\s*3\b/i,
  /makeover\s*4\b/i, /makeover\s*5\b/i, /makeover\s*6\b|makeover\s*\(\s*the big 3/i, /makeover\s*7\b/i,
  /^baby glow\b(?!.*(hands|upper))/i, /^(the )?re[ng]e[nr]e?[rg]ie/i, /makeover\s*9\b/i, /laser genesis add-on.*10,?000/i,
];
export const flyerRank = (s) => { const n = cleanName(s?.name); const i = FLYER_PROMOS.findIndex((re) => re.test(n)); return i === -1 ? (/laser genesis add-on/i.test(n) ? 12.5 : 99) : i + (/regenerie/i.test(n) ? 0.5 : 0); };
// Legacy/duplicate Square items that should not surface in the client menu
export const isLegacyHidden = (s) => /maker over|makeover 9--\$349|do not book|^\s*combo\s+\d+\s*mins?\s*$/i.test(cleanName(s?.name));

export const promoCompare = (a, b) => flyerRank(a) - flyerRank(b) || makeoverNum(a) - makeoverNum(b) || azCompare(a, b);

// Flyer order, one item per flyer slot; extra matches (duplicates/variants) follow the flyer block
export const sortPromos = (list) => {
  const sorted = [...list].sort(promoCompare);
  const seen = new Set(); const first = []; const dupes = []; const rest = [];
  for (const s of sorted) {
    const r = Math.floor(flyerRank(s));
    if (r === 99) rest.push(s); else if (seen.has(r)) dupes.push(s); else { seen.add(r); first.push(s); }
  }
  return [...first, ...dupes, ...rest];
};

// Returns [[category, services]] in MENU_ORDER, each list A→Z
export const groupByMenu = (services) => {
  const groups = {};
  for (const s of services) (groups[menuCategory(s)] ||= []).push(s);
  return MENU_ORDER.filter((c) => groups[c]).map((c) => [c, groups[c].sort(azCompare)]);
};

export const KARINE_INJECTABLE_KEYWORDS = [
  "botox", "dysport", "neuromod", "neurotoxin", "xeomin", "nuceiva",
  "filler", "syringe", "lip enhancement", "lip plump",
  "cheek filler", "jaw filler", "jawline filler", "chin filler",
  "tear trough", "nasolabial", "marionette", "hand rejuvenation",
  "sculptra", "radiesse",
  "skin booster", "profhilo", "polynuc", "baby glow", "nctf",
  "redensity",
  "sclerotherapy", "vein injection", "spider vein injection",
  "nefertiti", "platysmal", "lip flip",
  "tmj injection", "bruxism", "hyperhidrosis", "underarm sweat",
  "frown", "11's", " 11s ", "forehead line", "forehead promo",
  "crow's feet", "crows feet", "crow feet",
  "upper face", // "Full Upper Face" $599 Botox promo
  "prp ", "prp.", "prp,", "platelet", "vampire facelift", "vampire facial",
  "luscious", "radiant lip", "door crasher",
  "medical microneedling", "morpheus", "sylfirm",
];
export const TANYA_SERVICE_KEYWORDS = [
  "éminence", "eminence", "stone crop", "arctic berry", "bamboo",
  "hand renewal", "lip renewal", "extended extraction", "extraction add",
  "hydrafacial", "hydra facial", "crown facial", "glow facial",
  "lip perk", "dermaplaning", "diamond tip", "chemical peel", "peel ",
  "laser hair removal", "laser hair", "laser genesis", "ipl",
  "photofacial", "laser ", "lhr ", "lhr.", "elite+",
  "laser women", "laser men", "laser intimate", "brazilian", "bikini",
  "rf microneedling", "rf micro needling", "potenza",
  "rejuvapen",
  "skin tightening", "skin rejuvenation", "facial lymphatic", "lymphatic drainage",
  "led light", "led therapy",
  "acne treatment", "acne facial", "pigmentation treatment",
  "lesion removal", "vein removal", "dark spot", "telangiec",
  "skincare consult", "skin consult", "medical-grade skincare",
  "free consultation", "follow up", "virtual consultation",
  "rf ", " rf+", " rf-", "rf+",
];
const hasKw = (s, kws) => { const n = (s?.name || "").toLowerCase(); return kws.some((k) => n.includes(k)); };
// Who performs it — Linda (NP) by name, Karine = injectables, Tanya = skin/laser
export const providerOf = (s) => {
  const n = (s?.name || "").toLowerCase();
  if (/linda|lafrance|nurse practitioner|\bnp\b/.test(n)) return "linda";
  if (/karine|lauzon/.test(n)) return "karine";
  if (/tanya|aesthetician/.test(n)) return "tanya";
  if (hasKw(s, KARINE_INJECTABLE_KEYWORDS)) return "karine";
  if (hasKw(s, TANYA_SERVICE_KEYWORDS)) return "tanya";
  const c = menuCategory(s);
  return ["Botox & Neuromodulators", "Fillers, Skin Boosters & Regenerative", "Consultations", "Other Treatments"].includes(c) ? "karine" : "tanya";
};

const cat = (...cs) => (s) => cs.includes(menuCategory(s));
export const QUICK_FILTERS = [
  { id: "all", en: "All", fr: "Tout", test: () => true },
  { id: "promos", en: "Promotions", fr: "Promotions", test: (s) => isPromoService(s) },
  { id: "botox", en: "Botox", fr: "Botox", test: (s) => !/syringe|filler/i.test(s.name || "") && (menuCategory(s) === "Botox & Neuromodulators" || (isPromoService(s) && /makeover\s*[1-7]\b|360|upper face|nefertiti|big 3|glow choice/i.test(s.name || ""))) },
  { id: "filler", en: "Filler", fr: "Filler", test: (s) => !/laser|[ée]minence|hydrafacial|facial|perk|renewal/i.test(s.name || "") && /filler|\brha\b|juv[eé]derm|restylane|radiesse|syringe|\blips?\b(?!\s*flip)|cheek|tear trough|lip stick/i.test(s.name || "") },
  { id: "boosters", en: "Sculptra & Skin Boosters", fr: "Sculptra & Skin Boosters", test: (s) => /sculptra|booster|redensity|baby glow|profhilo|\bprp\b|exosome|regenerie|renergie|makeover\s*9|glow reset/i.test(s.name || "") },
  { id: "microneedling", en: "Microneedling", fr: "Microneedling", test: (s) => cat("Microneedling & RF")(s) || /microneedl|micro needl/i.test(s.name || "") },
  { id: "facials", en: "Facials & Peels", fr: "Soins du visage", test: cat("Facials, Hydrafacial & Peels") },
  { id: "laser", en: "Laser & IPL", fr: "Laser & IPL", test: cat("Icon IPL (Tanya · Ottawa)", "Laser Genesis & IPL", "Laser Hair Removal") },
  { id: "icon", en: "Icon IPL · NEW", fr: "IPL Icon · NOUVEAU", test: cat("Icon IPL (Tanya · Ottawa)") },
  { id: "consult", en: "Free consults", fr: "Consultations", test: cat("Consultations") },
  { id: "karine", en: "Karine's", fr: "Karine", test: (s) => providerOf(s) === "karine" },
  { id: "tanya", en: "Tanya's", fr: "Tanya", test: (s) => providerOf(s) === "tanya" },
  { id: "linda", en: "Linda's (NP)", fr: "Linda (IP)", test: (s) => providerOf(s) === "linda" },
];

// ── Treatment codes (#12, #A7, #L1) — mirror of backend name_key ──────────
export const codeKey = (name) => {
  const n = cleanName(name);
  const fi = FLYER_PROMOS.findIndex((re) => re.test(n));
  if (fi !== -1) return `flyer ${fi + 1}`;
  const base = cleanName(name).toLowerCase().replace(/\s*[-—(]*\s*\$\s?[\d,]+(\s*\+\s*(tx|tax))?\s*(plus tax)?\)?/g, " ");
  return base.replace(/[^a-z0-9]+/g, " ").trim();
};
let _codes = null; let _codesPromise = null;
export const loadTreatmentCodes = () => {
  if (_codes) return Promise.resolve(_codes);
  if (!_codesPromise) {
    _codesPromise = fetch(`${process.env.REACT_APP_BACKEND_URL}/api/treatments/codes`).then((r) => r.json()).then((d) => { _codes = d.codes || {}; return _codes; }).catch(() => ({}));
  }
  return _codesPromise;
};
export const codeOf = (s, codes) => s?.code || (codes ? codes[codeKey(s?.name)] || null : null);
export const matchesCode = (query, s, codes) => {
  const q = (query || "").trim().replace(/^#/, "").toUpperCase();
  if (!q || !/^[AL]?\d{1,3}$/.test(q)) return false;
  const c = codeOf(s, codes);
  return !!c && c.toUpperCase() === q;
};

// Oct 21 2026 · plain-language search — what clients actually type → the
// treatments that address it. Each entry: [what the client types, what to
// look for in the service name / category / description].
export const PLAIN_WORDS = [
  [/forehead|front\b|lignes du front/i, /forehead|front\b|upper face|big 3|glabell|11'?s/i],
  [/frown|11'?s|between (my|the) (eyes|brows)|angry/i, /11'?s|frown|glabell|upper face|big 3/i],
  [/crow|eye wrinkle|eye lines|smile lines|pattes/i, /crow|upper face|big 3/i],
  [/brown spot|sun spot|age spot|dark spot|pigment|melasma|freckle|tache/i, /ipl|photofacial|limelight|pigment|peel|laser genesis|2d|brighten|c \+ e|vitamin c|cosmelan|spot/i],
  [/redness|rosacea|red face|broken (capillar|vessel)|flush/i, /ipl|photofacial|limelight|laser genesis|2d|redness|rosacea|calm|sensitive/i],
  [/dry skin|dehydrat|dull|hydrat|tight skin/i, /hydrafacial|skin booster|redensity|baby glow|hydrat|moistur|exosome|dry/i],
  [/lips?|lip fill|fuller lips|lip flip|pout/i, /lip/i],
  [/under ?eye|dark circle|tear trough|eye bag|hollow/i, /tear trough|under eye|redensity ii|redensity 2|eye/i],
  [/jaw|jowl|sagg|lift|neck|turkey|double chin|nefertiti/i, /nefertiti|jaw|neck|lift|sculptra|chin|kybella|platysm/i],
  [/acne|breakout|pimple|blackhead|congest|pores?/i, /acne|clarif|pore|hydrafacial|peel|clear|deep cleans|salicylic/i],
  [/scar|texture|rough|bumpy|pitted/i, /microneedl|micro needl|rf|laser genesis|exosome|texture|scar|prp/i],
  [/wrinkle|fine line|anti.?aging|aging|mature/i, /botox|filler|sculptra|microneedl|laser genesis|retinol|age|mature|wrinkle|line/i],
  [/hair removal|unwanted hair|shav|wax|brazilian|bikini|underarm|armpit|legs?/i, /laser hair|hair removal|brazilian|bikini|underarm|leg|unlimited/i],
  [/sweat|hyperhidrosis|armpit sweat/i, /hyperhidrosis|sweat/i],
  [/migraine|headache|tmj|grind|clench|jaw pain/i, /migraine|bruxism|masseter|tmj/i],
  [/cheek|volume|sunken|flat/i, /cheek|filler|sculptra|volume|redensity/i],
  [/facial|spa|relax|pamper/i, /facial|hydrafacial|éminence|eminence|aveda/i],
  [/consult|advice|not sure|help|question|new client/i, /consult|follow up/i],
  [/follow.?up|check.?in|touch.?up|top.?up/i, /follow up|touch|top up/i],
  [/peel|exfoliat|resurfac/i, /peel|resurfac|exfoliat/i],
  [/prp|plasma|vampire/i, /prp|plasma/i],
  [/sculptra|collagen/i, /sculptra|collagen|microneedl|laser genesis|exosome/i],
  [/mole|skin tag|lesion|wart/i, /lesion|mole|skin tag|wart|removal/i],
  [/cellulite|belly|stomach|body|tummy|fat/i, /body|sculpt|belly|abdomen|cellulite|tighten/i],
];

export const matchesPlainWords = (query, s) => {
  const q = (query || "").trim().toLowerCase();
  if (q.length < 3) return false;
  const text = `${s?.name || ""} ${s?.category || ""} ${s?.description || ""}`;
  return PLAIN_WORDS.some(([ask, find]) => ask.test(q) && find.test(text));
};

// One matcher for every search box: treatment number, exact text, or plain words.
export const matchesService = (query, s, codes) => {
  const q = (query || "").trim().toLowerCase();
  if (!q) return true;
  if (matchesCode(q, s, codes)) return true;
  if (`${s?.name || ""} ${s?.category || ""} ${s?.description || ""}`.toLowerCase().includes(q)) return true;
  return matchesPlainWords(q, s);
};
